import { color } from "@/styles/tokens";
import type { _SVGIcon } from "hsl-core/Components";

export const FILL = color.surface.cta;

const body: _SVGIcon.IconBody = (params) => {
	const fill = params?.fill ?? FILL;
	return `
    <g clip-path="url(#clip0_17499_167181)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.922703 0L0.220703 0.803L6.1607 6.001L0.220703 11.197L0.922703 12L7.7807 6L0.922703 0Z" fill="${fill}"/>
    </g>
    <defs>
      <clipPath id="clip0_17499_167181">
        <rect width="8" height="12" fill="white"/>
      </clipPath>
    </defs>
  `;
};

export default {
	W: 8,
	H: 12,
	body,
} as _SVGIcon.Icon;
